const quem_somos = {
    compromissos: [
        {
            title: "Representar",
            text: "Um mercado forte se faz com instituições fortes e bem representadas. Contribuímos para isso promovendo diálogos com o governo e com outras entidades do setor privado, para os quais apresentamos e discutimos propostas de melhorias do ambiente de negócios. Também elaboramos um conjunto de boas práticas que os associados seguem voluntariamente, por meio da adesão aos nossos códigos de autorregulação."
        },
        {
            title: "Autorregular",
            text: "Desenvolvemos regras feitas pelo mercado, para o mercado e em prol do próprio mercado: são boas práticas que as instituições seguem voluntariamente. Nossa equipe técnica acompanha de perto o cumprimento dessas exigências, supervisionando e orientando as instituições."
        },
        {
            title: "Informar",
            text: "A partir de uma base de dados consistente, somos a principal provedora de informações dos segmentos que representamos. Isso é feito com a divulgação de estatísticas, rankings, referências de preços e índices que acompanham o comportamento das carteiras de ativos, além de estudos específicos que interessem aos associados."
        },
        {
            title: "Educar",
            text: "Acreditamos que é possível transformar o mercado por meio da capacitação de seus principais agentes: profissionais e investidores. Por isso, nossas ações buscam qualificar os profissionais com certificações, para que eles sejam multiplicadores de informações e de boas práticas. Também produzimos e divulgamos conteúdos sobre educação financeira para investidores e população em geral."
        }
    ]
};

export { quem_somos };
